import { UNAUTHORIZED } from 'core/api/apiHelpers';
import {
commandDeleteFailed, commandGetFailed, commandSaveFailed,
  commandUpdateFailed, } from 'core/redux/actions/command/commandActions';
import { configurationLoaded } from 'core/redux/actions/configuration/configurationActions';
import { pageLoadingFailed, pinLeftSidebar, unpinLeftSidebar } from 'core/redux/actions/page/pageActions';
import {
  loadSession, loggedOutUser, updateUserSettingsRecentItemsPinned,
} from 'core/redux/actions/user/userActions';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import type {
AnyAction,
  Middleware, } from 'redux';

const userMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  // Once the configuration is loaded, we can call the /static endpoint
  // to get the current session information and the final configuration
  if (configurationLoaded.match(action) && action.payload.source === 'static') {
    (store.dispatch as AppThunkDispatch)(loadSession(action.payload.imgRootUrl));
  } else if (pinLeftSidebar.match(action)) {
    (store.dispatch as AppThunkDispatch)(updateUserSettingsRecentItemsPinned(true));
  } else if (unpinLeftSidebar.match(action)) {
    (store.dispatch as AppThunkDispatch)(updateUserSettingsRecentItemsPinned(false));
  } else if (
    pageLoadingFailed.match(action)
    || commandUpdateFailed.match(action)
    || commandGetFailed.match(action)
    || commandSaveFailed.match(action)
    || commandDeleteFailed.match(action)
  ) {
    if (action.payload.errorResponse?.status === UNAUTHORIZED) {
      (store.dispatch(loggedOutUser()));
    }
  }

  next(action);
};

export default userMiddleware;
